import { SvgParameterDc } from "@evergis/api";

import { isSvgPointSymbol, PointSymbol, PointSymbolType } from "../../../interfaces/style";

export const getSymbolStrokeWidth = (symbol: PointSymbolType): number => {
  return isSvgPointSymbol(symbol)
    ? ((symbol.background as SvgParameterDc)?.strokeWidth as number) ||
        ((symbol.figure as SvgParameterDc)?.strokeWidth as number)
    : ((symbol as PointSymbol).strokeWidth as number);
};
